"use client";

import PhoneAuthForm, { AuthFooterLink } from '@/components/auth/PhoneAuthForm';

export default function RegisterContent() {
  return (
    <PhoneAuthForm
      mode="signup"
      title="Create Your Account"
      subtitle="All it takes is your mobile number"
      submitLabel="Send code"
      footer={
        <AuthFooterLink href="/login" prompt="Already have an account?" action="Sign in" />
      }
    />
  );
}
